// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"791":"ca6a875e6dcbc784","882":"6be5934809ff6a04"}[chunkId] + ".js";
};